var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeightLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Height lock ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Height-lock-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Height",
    transform: "translate(4.000000, 3.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Down",
    transform: "translate(3.793424, 8.131313) scale(1, -1) translate(-3.793424, -8.131313) ",
    points: "0.611605927 10.040404 6.97524229 10.040404 3.79342411 6.22222222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Up",
    points: "0.611605927 4.38383838 6.97524229 4.38383838 3.79342411 0.565656566"
  })), /*#__PURE__*/React.createElement("g", {
    id: 560062,
    transform: "translate(9.000000, 2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.68001091,1.31530364 L2.66952182,1.31530364 L2.66952182,0.693163636 C2.66952182,0.310336364 2.35918545,0 1.97635818,0 C1.59353636,0 1.28319455,0.310336364 1.28319455,0.693163636 L1.28319455,1.31530364 L1.27270545,1.31530364 L1.003,1.31530364 C0.830082528,1.97318068 0.830082528,2.46565341 1.003,2.79272182 C1.26237621,3.28332443 1.67406977,3.20110036 2,3.20110036 C2.32593023,3.20110036 2.72279534,3.24331398 2.94972182,2.79272182 C3.10100614,2.49232704 3.10100614,1.99985431 2.94972182,1.31530364 L2.68001091,1.31530364 Z M2.14781091,2.11276364 L2.14781091,2.49073091 L1.80491091,2.49073091 L1.80491091,2.11276364 C1.73818,2.06031273 1.69895636,1.98036 1.69895636,1.89470727 C1.69895636,1.74174545 1.82340182,1.6173 1.97636364,1.6173 C2.12932545,1.6173 2.25377091,1.74174545 2.25377091,1.89470727 C2.25377091,1.98036545 2.21454182,2.06031818 2.14781091,2.11276364 Z M2.40877273,1.31530364 L1.54394364,1.31530364 L1.54394364,0.693163636 C1.54394364,0.454729091 1.73792364,0.260749091 1.97635818,0.260749091 C2.21479273,0.260749091 2.40877273,0.454729091 2.40877273,0.693158182 L2.40877273,1.31530364 L2.40877273,1.31530364 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightLock);
export default __webpack_public_path__ + "static/media/Height_lock.ba237419.svg";
export { ForwardRef as ReactComponent };